module.exports = __webpack_public_path__ + "dimer/static/img/25.bd279fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/25.jpg
// module id = r2u7
// module chunks = 0